import { render, staticRenderFns } from "./measure-instructions.vue?vue&type=template&id=3ba56acd"
import script from "./measure-instructions.vue?vue&type=script&lang=js"
export * from "./measure-instructions.vue?vue&type=script&lang=js"
import style0 from "./measure-instructions.vue?vue&type=style&index=0&id=3ba56acd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports